import React from 'react';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';

const asset3dLabel = 'Assets';

//3d asset count component for displaying asset count on all creat asset work flow pages
const AssetsHeaderWithCount = () => {
	const assets = useSelector((state) => state.assets);
	const assetsCount = `${assets.length} ${asset3dLabel}`;
	return (
		<Typography data-cy='asset-count' variant='body1'>
			{assetsCount}
		</Typography>
	);
};

export default AssetsHeaderWithCount;
